import { FlowRunError } from '../ServerApi/types/FlowRunError';
import { FlowParameterRunInfo, IIdItemInfo } from './resourceInfoParts';

export type FlowOutputStepRunListItemInfo =
  IIdItemInfo & FlowParameterRunInfo & FlowParameterRunInfo & {
    flowId: string;
    startedAt: Date; // YYYY-MM-DDThh:mm:ssZ
    completedAt: Date; // YYYY-MM-DDThh:mm:ssZ
    status: string; // FlowOutputStepRunStatus
    rowsProduced: number;
    flowRunId: string;
    flowOutputStepId: string;
    publishedDataSourceId: string;
    publishedDataSourceName: string;
    outputName: string;
    flowRunErrors: ReadonlyArray<FlowRunError>;
    runType: FlowOutputStepRunType;
    isIncremental: boolean;
  };

export enum FlowOutputStepRunStatus {
  pending = 'PENDING',
  inProgress = 'INPROGRESS',
  success = 'SUCCESS',
  failed = 'FAILED',
  cancelled = 'CANCELLED',
}

export enum FlowOutputStepRunType {
  scheduled = 'SCHEDULED',
  ondemand = 'ONDEMAND',
  unknown = 'UNKNOWN',
}
